import { useContext } from "react";
import translate from "../locales";
import clsx from "clsx";
import { InputGroup } from "../components/form/input-group";
import { TextInput } from "../components/form/text-input";
import { TextLabel } from "../components/form/text-label";
import { Select } from "../components/form/select";
import { Option } from "../components/form/select-option";
import { Question } from "../components/form/question";

import { ExercisePage } from "../components/exercise-page";
import { ClassroomContext } from "../components/classroom.context";
import { NumberInput } from "../components/form/number-input";

export function ExercisePageCurrent2({ onPrevious, onNext }) {
  const { requireFields } = useContext(ClassroomContext);

  return (
    <ExercisePage
      title="exercise.current_2.title"
      description="exercise.current_2.description"
      labelNext="exercise.current_2.button-next"
      onPrevious={onPrevious}
      showSources
      onNext={onNext}
      buttonNextDisabled={
        !requireFields([
          "tactic_1",
          "deaths",
          "injured",
          "number_victims",
          "damage",
        ])
      }
    >
      <title>{translate("exercise.current_2.page-title")}</title>
      <div className="exercise-card">
        <Question
          question="exercise.current_2.question_1.question"
          description="exercise.current_2.question_1.description"
        >
          <div className={clsx("flex-box", "flex-box_vertical")}>
            <InputGroup>
              <TextLabel
                for="tactic_1"
                label="exercise.current_2.question_1.tactic-label-before"
              />
              <TextInput
                id="tactic_1"
                placeholder="exercise.current_2.question_1.tactic-placeholder"
                maxLength={20}
              />
              <TextLabel
                for="tactic_1"
                label="exercise.current_2.question_1.tactic-label-after"
              />
            </InputGroup>
            <InputGroup>
              <TextLabel
                for="tactic_2"
                label="exercise.current_2.question_1.tactic-label-before"
              />
              <TextInput
                id="tactic_2"
                required={false}
                placeholder="exercise.current_2.question_1.tactic-placeholder"
                maxLength={20}
              />
              <TextLabel
                for="tactic_2"
                label="exercise.current_2.question_1.tactic-label-after"
              />
            </InputGroup>
            <InputGroup>
              <TextLabel
                for="tactic_3"
                label="exercise.current_2.question_1.tactic-label-before"
              />
              <TextInput
                id="tactic_3"
                required={false}
                placeholder="exercise.current_2.question_1.tactic-placeholder"
                maxLength={20}
              />
              <TextLabel
                for="tactic_3"
                label="exercise.current_2.question_1.tactic-label-after"
              />
            </InputGroup>
          </div>
        </Question>

        <Question
          question="exercise.current_2.question_2.question"
          description="exercise.current_2.question_2.description"
        >
          <div className={clsx("flex-box", "flex-box_column-mobile")}>
            <InputGroup>
              <TextLabel
                center
                for="deaths"
                label="exercise.current_2.question_2.deaths-label-before"
              />
              <NumberInput
                id="deaths"
                placeholder="exercise.current_2.question_2.deaths-placeholder"
              />
              <TextLabel
                center
                for="deaths"
                label="exercise.current_2.question_2.deaths-label-after"
              />
            </InputGroup>
            <InputGroup>
              <TextLabel
                center
                for="injured"
                label="exercise.current_2.question_2.injured-label-before"
              />
              <NumberInput
                id="injured"
                placeholder="exercise.current_2.question_2.injured-placeholder"
              />
              <TextLabel
                center
                for="injured"
                label="exercise.current_2.question_2.injured-label-after"
              />
            </InputGroup>
            <InputGroup>
              <TextLabel
                center
                for="number_victims"
                label="exercise.current_2.question_2.victims-label-before"
              />
              <NumberInput
                id="number_victims"
                placeholder="exercise.current_2.question_2.victims-placeholder"
              />
              <TextLabel
                center
                for="number_victims"
                label="exercise.current_2.question_2.victims-label-after"
              />
            </InputGroup>
          </div>
        </Question>

        <Question
          question="exercise.current_2.question_3.question"
          description="exercise.current_2.question_3.description"
        >
          <InputGroup>
            <Select multiple required={false} name="damage">
              <Option
                description="exercise.current_2.question_3.damage-houses"
                value="houses"
              >
                <svg
                  width="61"
                  height="61"
                  viewBox="0 0 61 61"
                  fill="none"
                  className="option-container__icon"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_437_784)">
                    <path
                      d="M30.5044 6.74583C30.9537 6.75378 31.4102 6.91414 31.8535 7.2031L59.6578 29.1536C60.3723 29.8627 60.8741 31.39 60.1382 32.3321C59.4022 33.2742 57.8537 33.4005 56.9597 32.6063L30.5041 11.7305L4.04847 32.6063C3.15475 33.4001 1.57379 33.2984 0.869997 32.3321C0.252757 31.4837 0.40442 29.8609 1.35032 29.1536L11.4798 21.1507V8.94047C11.4798 8.3584 11.7109 7.8002 12.1228 7.38832C12.5343 6.97682 13.0925 6.74536 13.6749 6.74536H19.5285C20.1106 6.74536 20.6688 6.97682 21.0803 7.38832C21.4921 7.80019 21.7232 8.35847 21.7236 8.94047V13.0792L29.1551 7.203C29.6123 6.88152 30.0548 6.7378 30.5042 6.74574L30.5044 6.74583ZM17.3337 11.1361H15.8704V17.6984L17.3337 16.5324V11.1361ZM48.065 28.171L52.4553 31.6467V52.8429V52.8426C52.4553 53.4246 52.2238 53.9828 51.8123 54.3947C51.4004 54.8062 50.8421 55.0377 50.2602 55.0377H37.0895C36.5074 55.0377 35.9488 54.8062 35.5373 54.3947C35.1258 53.9828 34.8944 53.4245 34.8944 52.8426V40.4038H26.1138V52.8426C26.1138 53.4246 25.8827 53.9828 25.4708 54.3947C25.0593 54.8062 24.5011 55.0377 23.9187 55.0377H10.748C10.1659 55.0377 9.60772 54.8062 9.19584 54.3947C8.78434 53.9828 8.55288 53.4245 8.55288 52.8426V31.6463L12.9432 28.1706V50.6468H21.7238V38.2081V38.2085C21.7238 37.6264 21.9548 37.0682 22.3667 36.6563C22.7782 36.2449 23.3365 36.0134 23.9185 36.0134H37.0892C37.6712 36.0134 38.2294 36.2449 38.6413 36.6563C39.0528 37.0682 39.2839 37.6265 39.2843 38.2085V50.6472H48.0648L48.065 28.171Z"
                      fill="#031037"
                    />
                    <circle
                      cx="30.5005"
                      cy="25.2777"
                      r="5.61377"
                      fill="#0081FF"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_437_784">
                      <rect
                        width="60"
                        height="60"
                        fill="white"
                        transform="translate(0.5 0.891479)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </Option>

              <Option
                description="exercise.current_2.question_3.damage-medical"
                value="medical"
              >
                <svg
                  width="61"
                  height="61"
                  viewBox="0 0 61 61"
                  fill="none"
                  className="option-container__icon"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M51.5316 58.3275H9.46606C6.29662 58.3275 3.72949 55.7604 3.72949 52.591V31.5569C3.72949 28.3874 6.29662 25.8203 9.46606 25.8203H15.2026V14.6557C15.2026 12.5953 16.3045 10.6951 18.0924 9.67441L27.6534 4.21015C29.4174 3.20388 31.5829 3.20388 33.3471 4.21015L42.9055 9.67441C44.6933 10.6951 45.7977 12.5953 45.7977 14.6557V25.8203H51.5317C54.7035 25.8203 57.2708 28.3874 57.2708 31.5569V52.591C57.2708 55.7604 54.7036 58.3275 51.5316 58.3275ZM26.6757 54.5031H34.3245V41.1178C34.3245 40.0613 33.4688 39.2056 32.4123 39.2056H28.5879C27.5314 39.2056 26.6757 40.0613 26.6757 41.1178V54.5031ZM41.9733 54.5031V14.6557C41.9733 13.9697 41.6075 13.3339 41.01 12.9945L31.449 7.53021C30.8586 7.19558 30.1392 7.19558 29.5512 7.53021L19.9902 12.9945C19.3927 13.3339 19.0269 13.9697 19.0269 14.6557V54.5031H22.8513V41.1178C22.8513 37.9484 25.4184 35.3813 28.5879 35.3813H32.4123C35.5793 35.3813 38.1463 37.9484 38.1463 41.1178V54.5031H41.9733ZM15.2026 29.6447H9.46606C8.41196 29.6447 7.55387 30.5004 7.55387 31.5569V52.591C7.55387 53.6474 8.41196 54.5031 9.46606 54.5031H15.2026V29.6447ZM45.7976 54.5031H51.5316C52.5881 54.5031 53.4462 53.6474 53.4462 52.591V31.5569C53.4462 30.5004 52.5881 29.6447 51.5316 29.6447H45.7976V54.5031Z"
                    fill="#031037"
                  />
                  <path
                    d="M26.3181 19.0736H28.409V21.1645C28.409 22.3197 29.3447 23.2554 30.4999 23.2554C31.6551 23.2554 32.5908 22.3197 32.5908 21.1645V19.0736H34.6817C35.8369 19.0736 36.7725 18.138 36.7725 16.9827C36.7725 15.8275 35.8369 14.8919 34.6817 14.8919H32.5908V12.801C32.5908 11.6457 31.6551 10.7101 30.4999 10.7101C29.3447 10.7101 28.409 11.6457 28.409 12.801V14.8919H26.3181C25.1629 14.8919 24.2246 15.8275 24.2246 16.9827C24.2246 18.138 25.1629 19.0736 26.3181 19.0736Z"
                    fill="#0081FF"
                  />
                </svg>
              </Option>

              <Option
                description="exercise.current_2.question_3.damage-infrastructure"
                value="infrastructure"
              >
                <svg
                  width="61"
                  height="61"
                  viewBox="0 0 61 61"
                  fill="none"
                  className="option-container__icon"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.64004 56.5875C6.4607 56.5875 6.27888 56.5635 6.09974 56.5135C5.13099 56.2464 4.58708 55.3243 4.88549 54.4545L19.5687 11.6098C19.8653 10.7385 20.8969 10.2483 21.862 10.5196C22.8308 10.7867 23.3747 11.7088 23.0763 12.5786L8.39302 55.4233C8.15098 56.1319 7.42408 56.5875 6.64004 56.5875Z"
                    fill="#0081FF"
                  />
                  <path
                    d="M54.3614 56.5873C53.5764 56.5873 52.8504 56.1319 52.6065 55.4232L37.9232 12.5784C37.6257 11.7087 38.1687 10.7866 39.1384 10.5195C40.1081 10.2467 41.1333 10.7407 41.4327 11.6097L56.1159 54.4544C56.4134 55.3242 55.8704 56.2463 54.9007 56.5133C54.7216 56.5631 54.5388 56.5873 54.3614 56.5873Z"
                    fill="#0081FF"
                  />
                  <path
                    d="M30.4995 56.5873C29.486 56.5873 28.6641 55.5599 28.6641 54.293V40.5274C28.6641 39.2606 29.486 38.2332 30.4995 38.2332C31.513 38.2332 32.3349 39.2606 32.3349 40.5274V54.293C32.3349 55.5599 31.513 56.5873 30.4995 56.5873Z"
                    fill="#031037"
                  />
                  <path
                    d="M30.4995 35.9964C29.486 35.9964 28.6641 34.9779 28.6641 33.7221V24.6253C28.6641 23.3695 29.486 22.3511 30.4995 22.3511C31.513 22.3511 32.3349 23.3695 32.3349 24.6253V33.7221C32.3349 34.9779 31.513 35.9964 30.4995 35.9964Z"
                    fill="#031037"
                  />
                  <path
                    d="M30.5004 20.1146C29.487 20.1146 28.665 19.032 28.665 17.6971V12.8623C28.665 11.5274 29.487 10.4448 30.5004 10.4448C31.5139 10.4448 32.3359 11.5274 32.3359 12.8623V17.6971C32.3359 19.032 31.5139 20.1146 30.5004 20.1146Z"
                    fill="#031037"
                  />
                  <path
                    d="M54.3597 38.233C53.3453 38.233 52.5243 37.4111 52.5243 36.3976V12.4614C52.5243 10.479 50.913 8.86674 48.9306 8.86674H12.0692C10.0868 8.86674 8.47452 10.479 8.47452 12.4614V36.3976C8.47452 37.4111 7.6526 38.233 6.63912 38.233C5.62563 38.233 4.80371 37.4111 4.80371 36.3976V12.4614C4.80371 8.45546 8.0633 5.19568 12.0695 5.19568H48.9308C52.9368 5.19568 56.1956 8.45526 56.1956 12.4614V36.3976C56.1956 37.4111 55.3746 38.233 54.3602 38.233H54.3597Z"
                    fill="#031037"
                  />
                </svg>
              </Option>

              <Option
                description="exercise.current_2.question_3.damage-military"
                value="military"
              >
                <svg
                  width="61"
                  height="61"
                  viewBox="0 0 61 61"
                  fill="none"
                  className="option-container__icon"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_437_769)">
                    <path
                      d="M53.6777 29.3971C54.5101 29.3972 55.1855 30.0725 55.1855 30.9049V41.9303C55.1854 42.7626 54.51 43.437 53.6777 43.4371H42.6484C41.8161 43.4371 41.1408 42.7626 41.1406 41.9303V30.9049C41.1406 30.0724 41.816 29.3971 42.6484 29.3971H53.6777ZM52.7588 41.0104V41.0114V41.0104ZM44.1562 40.4225H52.1699V39.7653H44.1562V40.4225ZM44.1562 36.7496H52.1699V36.0885H44.1562V36.7496ZM44.1562 33.0729H52.1699V32.4117H44.1562V33.0729Z"
                      fill="#0081FF"
                    />
                    <path
                      d="M18.5518 29.3971C19.3841 29.3971 20.0593 30.0717 20.0596 30.9039V41.9303C20.0593 42.7626 19.3841 43.4371 18.5518 43.4371H7.52246C6.69029 43.4369 6.01586 42.7624 6.01562 41.9303V30.9039C6.01587 30.0718 6.69034 29.3973 7.52246 29.3971H18.5518ZM17.6328 41.0104V41.0114V41.0104ZM9.03027 40.4225H17.0449V39.7653H9.03027V40.4225ZM9.03027 36.7496H17.0449V36.0885H9.03027V36.7496ZM9.03027 33.0729H17.0449V32.4117H9.03027V33.0729Z"
                      fill="#0081FF"
                    />
                    <path
                      d="M30.498 9.16394C38.5017 9.16394 46.0389 12.3274 51.7168 18.0653C57.3777 23.7867 60.498 31.3578 60.498 39.3807V51.1249C60.498 51.9574 59.8227 52.6327 58.9902 52.6327H2.00586C1.17336 52.6327 0.498047 51.9573 0.498047 51.1249V39.3807C0.498098 31.3579 3.61813 23.7862 9.2793 18.0653C14.9572 12.3276 22.4943 9.16395 30.498 9.16394ZM30.498 12.1776C15.6235 12.1776 3.51367 24.3778 3.51367 39.3807V49.6171H22.5566V30.9393C22.5566 30.1068 23.232 29.4315 24.0645 29.4315H36.9395C37.7718 29.4317 38.4473 30.107 38.4473 30.9393V49.6171H57.4824V39.3807C57.4824 24.3773 45.3727 12.1776 30.498 12.1776ZM25.5723 41.0819C25.843 40.6791 26.3026 40.414 26.8242 40.4139C27.6566 40.4141 28.332 41.0893 28.332 41.9218C28.3316 42.7538 27.6564 43.4285 26.8242 43.4286C26.3024 43.4285 25.8429 43.1626 25.5723 42.7596V49.6171H35.4316V32.4452H25.5723V41.0819ZM3.63184 33.1112C3.16909 35.1264 2.92482 37.2249 2.9248 39.3798V39.3807C2.9248 37.2259 3.16912 35.1274 3.63184 33.1122V33.1112ZM24.9834 31.8583H36.0205V31.8573H24.9834V31.8583ZM56.1553 29.2001C56.2377 29.4105 56.318 29.622 56.3955 29.8348L56.1562 29.2001C56.0738 28.9898 55.9887 28.7809 55.9014 28.5731L56.1553 29.2001ZM55.3486 27.3427C55.2606 27.1588 55.1701 26.9764 55.0781 26.7948C55.17 26.9764 55.2606 27.1588 55.3486 27.3427ZM54.9971 26.6366C54.928 26.5024 54.8573 26.3691 54.7861 26.2362C54.8572 26.3692 54.9281 26.5024 54.9971 26.6366Z"
                      fill="#031037"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_437_769">
                      <rect
                        width="60"
                        height="60"
                        fill="white"
                        transform="translate(0.5 0.891479)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </Option>
            </Select>
          </InputGroup>
        </Question>
      </div>
    </ExercisePage>
  );
}
